<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="类型筛选">
          <el-button-group>
            <el-button @click="changeTypeFunc('')">不限</el-button>
            <el-button :type="formInline.type == item.key_name ? 'primary' : ''" plain v-for="(item, index) in typeData" :key="index" @click="changeTypeFunc(item.key_name)">{{item.name}}</el-button>
          </el-button-group>
        </el-form-item>

        <el-form-item label="分类">
          <el-cascader size="small" v-model="formInline.category_ids" clearable :options="cateList" :props="propsParam" @change="handleChange"></el-cascader>
        </el-form-item>
        <br>

        <el-form-item label="用户id">
          <el-input v-model="formInline.user_id" placeholder="请输入" clearable></el-input>
        </el-form-item>

        <el-form-item label="解锁分类(id)">
          <el-input v-model="formInline.record_id" placeholder="请输入" clearable></el-input>
        </el-form-item>

        <el-form-item label="添加时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>

        <!-- <el-form-item label="结束日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.end_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="user" label="微信头像" width="70">
            <template slot-scope="scope" v-if="scope.row.user">
              <img :src="scope.row.user.avatarUrl" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="用户" width="200">
            <template slot-scope="scope" v-if="scope.row.user">
              <p>用户ID：{{scope.row.user.user_id}}</p>
              <p>昵称：{{scope.row.user.nickName}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="record_name" label="解锁分类(id)">
            <template slot-scope="scope" v-if="scope.row.user">
              {{scope.row.record_name}} ({{scope.row.record_id}})
            </template>
          </el-table-column>
          <el-table-column prop="end_day" label="剩余天数" width="140" align="center"></el-table-column>
          <el-table-column prop="end_time" label="过期时间" width="140" align="center"></el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="name" label="操作" width="120">
              <template slot-scope="scope">
                  <el-button @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
              </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import CodeUserApi from '@/api/study/code_user.js';
  import CategoryApi from '@/api/study/category.js';
  import qs from 'qs';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*展示数据*/
        propsParam: {
          label: 'name',
          value: 'category_id',
        },
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          type: '',
          user_id: '',
          create_time: '',
          end_time: '',
          category_ids: '',
        },
        typeData: {},
        cateList: [],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      // 默认
      let type = this.$db.getRouteField(this, 'type');
      if (type) this.formInline.type = type;

      let category_ids = this.$db.getRouteField(this, 'category_ids');
      if (category_ids) this.formInline.category_ids = category_ids;

      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*跳转详情*/
      onDetail(row) {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let params = {question_id: row.question_id};
        baseUrl = this.$filter.isDebug() ? '' : '/shop';
        window.open(baseUrl + '/#/study/questionlibrary/index?' + qs.stringify(params));
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        CodeUserApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.totalDataNumber = data.total;
          self.typeData = data.type;
          self.cateList = data.category;
          self.cateList.unshift({name:'顶级',category_id:0});
        }).catch(error => {
          self.loading = false;
        });
      },

      /*删除*/
      deleteFun(row) {
          let self = this;
          self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() =>{
              self.loading = true;
              CodeUserApi.del({
                  id: row.id
              }, true)
                  .then(data =>{
                      self.loading = false;
                      self.$message({
                          message: data.msg,
                          type: 'success'
                      });
                      self.getTableList();
                  })
                  .catch(error =>{
                      self.loading = false;
                  });

          }).catch(() =>{});
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*选择类型*/
      changeTypeFunc(e){
        this.formInline.type = e;
        this.formInline.category_ids = [];
        this.$db.setRoute(this, {'type': e, 'category_ids': []});
        this.getTableList();
      },

      /*选择类型*/
      typeChange(){
          let self = this;
          CategoryApi.getList({type:this.formInline.type}, true).then(res => {
              if (res.code == 1) {
                  self.cateList = res.data.list
              }
          });
      },

      /*选择分类*/
      handleChange(e) {
        this.$db.setRoute(this, {type:this.formInline.type, category_ids:this.formInline.category_ids});
        this.getTableList();
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/code/user/Index.vue